/*============================================================================
  COMPONENT — ZOOM (fullscreen image viewer)
  Delegated on [data-zoom] triggers; needs component_zoom's <dialog> in the
  page. The native dialog handles ESC, the inert background and focus
  restitution, so none of that is re-implemented here.
==============================================================================*/

(function () {
  'use strict';

  var viewer, stage, image, counter, controls;
  var gallery = [];
  var current = 0;
  var pan = null;
  var dragged = false;

  /* every zoomable trigger in the page, in document order */
  function collect() {
    gallery = Array.prototype.slice.call(document.querySelectorAll('[data-zoom]'));
  }

  /* the Carnet counter reads 01 / 04 */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function show(i) {
    var trigger = gallery[i];
    if (!trigger) return;
    var source = trigger.querySelector('img');

    current = i;

    /* landscape shots are turned by the CSS when the phone is held upright, so
       they span the screen height. sizes has to say so: it drives both the
       rendered width and the source the browser picks. */
    var landscape = !!source && source.naturalWidth > source.naturalHeight;
    viewer.classList.toggle('is-landscape', landscape);
    if (landscape) {
      image.sizes = '(orientation: portrait) and (max-width: 768px) 95vh, 95vw';
    } else {
      image.sizes = '95vw';
    }

    image.srcset = trigger.getAttribute('data-zoom-srcset') || '';
    image.src = trigger.getAttribute('href');
    image.alt = source ? source.alt : '';

    var template = counter.getAttribute('data-counter-template') || '%index% / %total%';
    counter.textContent = template
      .replace('%index%', pad(i + 1))
      .replace('%total%', pad(gallery.length));

    // a lone image has nowhere to go
    controls.hidden = gallery.length < 2;
    unzoom();
  }

  function step(direction) {
    show((current + direction + gallery.length) % gallery.length);
  }

  function open(i) {
    show(i);
    viewer.showModal();
    document.body.style.overflow = 'hidden';
  }

  function close() {
    viewer.close();
  }

  function unzoom() {
    viewer.classList.remove('is-zoomed');
    stage.scrollTop = 0;
    stage.scrollLeft = 0;
  }

  /* runs on close and on ESC alike */
  function onDismiss() {
    unzoom();
    document.body.style.overflow = '';
  }

  /* fit-to-screen <-> natural size, centred on what was already centred */
  function toggleZoom() {
    if (viewer.classList.contains('is-zoomed')) {
      unzoom();
      return;
    }
    viewer.classList.add('is-zoomed');
    stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2;
    stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2;
  }

  function startPan(e) {
    if (e.pointerType === 'touch') return; // touch scrolls and pinches natively
    if (!viewer.classList.contains('is-zoomed')) return;
    pan = { x: e.clientX, y: e.clientY, left: stage.scrollLeft, top: stage.scrollTop };
    stage.setPointerCapture(e.pointerId);
  }

  function movePan(e) {
    if (!pan) return;
    var dx = e.clientX - pan.x;
    var dy = e.clientY - pan.y;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) dragged = true;
    stage.scrollLeft = pan.left - dx;
    stage.scrollTop = pan.top - dy;
  }

  function endPan() {
    pan = null;
  }

  function onClick(e) {
    var trigger = e.target.closest('[data-zoom]');
    if (trigger) {
      e.preventDefault();
      open(gallery.indexOf(trigger));
      return;
    }

    if (!viewer.open) return;

    // the click that closes a drag is not a click on anything
    if (dragged) {
      dragged = false;
      return;
    }

    if (e.target.closest('[data-zoom-close]')) {
      close();
      return;
    }

    var stepper = e.target.closest('[data-zoom-step]');
    if (stepper) {
      step(parseInt(stepper.getAttribute('data-zoom-step'), 10));
      return;
    }

    if (e.target === image) {
      toggleZoom();
      return;
    }

    if (e.target.closest('[data-zoom-controls]')) return;

    close(); // anywhere on the bare background
  }

  function onKey(e) {
    if (!viewer.open || gallery.length < 2) return;
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      step(1);
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      step(-1);
    }
  }

  function init() {
    viewer = document.querySelector('[data-zoom-viewer]');
    if (!viewer || typeof viewer.showModal !== 'function') return;

    stage = viewer.querySelector('[data-zoom-stage]');
    image = viewer.querySelector('[data-zoom-img]');
    counter = viewer.querySelector('[data-zoom-counter]');
    controls = viewer.querySelector('[data-zoom-controls]');
    if (!stage || !image || !counter || !controls) return;

    collect();
    if (!gallery.length) return;

    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    stage.addEventListener('pointerdown', startPan);
    stage.addEventListener('pointermove', movePan);
    stage.addEventListener('pointerup', endPan);
    stage.addEventListener('pointercancel', endPan);
    viewer.addEventListener('close', onDismiss);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
